import { useCallback } from 'react';

import { useMutation } from '@apollo/client';
import UpdateReportJob from '@graphql/mutations/UpdateReportJob';
import Alert from 'react-s-alert';

const ALERT_OPTIONS = {
  position: 'top-right',
  effect: 'slide',
  beep: false,
  timeout: 4000,
};

export type UpdateReportQa = (
  id: number,
  passedQa: boolean | null,
  mapOnly: boolean,
) => Promise<boolean>;

/**
 * Set a report job's QA outcome. `passedQa` null puts it back in the queue.
 */
const useUpdateReportQa = (): {
  updateReportQa: UpdateReportQa;
  updating: boolean;
} => {
  const [mutate, { loading }] = useMutation(UpdateReportJob);

  const updateReportQa = useCallback<UpdateReportQa>(
    async (id, passedQa, mapOnly) => {
      try {
        await mutate({
          variables: { id, reportJobPatch: { passedQa, mapOnly } },
        });
        Alert.success('Changes saved successfully', ALERT_OPTIONS);
        return true;
      } catch (error) {
        console.error(error);
        Alert.error('Changes not saved. Please try again', ALERT_OPTIONS);
        return false;
      }
    },
    [mutate],
  );

  return { updateReportQa, updating: loading };
};

export default useUpdateReportQa;
